import IConfigurationModel, { ConfigurationModel } from "@/models/configuration-model";
import * as UrlConstants from '@/constants/url-constants'
import * as StorageConstants from '@/constants/storage-constants'

export default class InitConfigurationService {
    determine(): IConfigurationModel {
        const urlParams = new URLSearchParams(window.location.search);
        if (urlParams.has(UrlConstants.bagsize) || urlParams.has(UrlConstants.body)) {
            return this.determineUrlModel(urlParams)
        }
        if (this.hasLocalConfig()) {
            return this.determineLocalstorageModel()
        }
        return new ConfigurationModel()
    }

    private hasLocalConfig(): boolean {
        try {
            const bagsize = localStorage.getItem(StorageConstants.bagsize)
            if (bagsize && JSON.parse(bagsize)) {
                return true
            }
            const body = localStorage.getItem(StorageConstants.body)
            if (body && JSON.parse(body)) {
                return true
            }
            const edge = localStorage.getItem(StorageConstants.edge)
            if (edge && JSON.parse(edge)) {
                return true
            }
            const thread = localStorage.getItem(StorageConstants.thread)
            if (thread && JSON.parse(thread)) {
                return true
            }
            const noName = localStorage.getItem(StorageConstants.noName)
            if (noName && JSON.parse(noName)) {
                return true
            }
            const side = localStorage.getItem(StorageConstants.side)
            if (side && JSON.parse(side)) {
                return true
            }
            return false
        }
        catch (err) {
            // on some browser like LINE, there is no localstorage; ignore that error
            console.error(err)
            return false
        }
    }

    private determineUrlModel(urlParams: URLSearchParams): IConfigurationModel {
        let model = new ConfigurationModel()
        model.bagsize = this.formatIntParameter(urlParams.get(UrlConstants.bagsize))
        model.body = this.formatIntParameter(urlParams.get(UrlConstants.body))
        model.edge = this.formatIntParameter(urlParams.get(UrlConstants.edge))
        model.thread = this.formatIntParameter(urlParams.get(UrlConstants.thread))
        model.inside = this.formatIntParameter(urlParams.get(UrlConstants.inside))
        model.pocket = this.formatIntParameter(urlParams.get(UrlConstants.pocket))
        model.side = this.formatIntParameter(urlParams.get(UrlConstants.side))
        model.front = this.formatIntParameter(urlParams.get(UrlConstants.front))
        model.tack = this.formatIntParameter(urlParams.get(UrlConstants.tack))
        model.back = this.formatIntParameter(urlParams.get(UrlConstants.back))
        model.namechar = this.formatIntParameter(urlParams.get(UrlConstants.namechar))
        model.namethread = this.formatStringParameter(urlParams.get(UrlConstants.namethread))
        model.noName = this.formatIntParameter(urlParams.get(UrlConstants.noName))
        return model
    }

    private determineLocalstorageModel(): IConfigurationModel {
        let model = new ConfigurationModel()
        model.bagsize = this.formatIntParameter(localStorage.getItem(StorageConstants.bagsize))
        model.body = this.formatIntParameter(localStorage.getItem(StorageConstants.body))
        model.edge = this.formatIntParameter(localStorage.getItem(StorageConstants.edge))
        model.thread = this.formatIntParameter(localStorage.getItem(StorageConstants.thread))
        model.inside = this.formatIntParameter(localStorage.getItem(StorageConstants.inside))
        model.pocket = this.formatIntParameter(localStorage.getItem(StorageConstants.pocket))
        model.side = this.formatIntParameter(localStorage.getItem(StorageConstants.side))
        model.front = this.formatIntParameter(localStorage.getItem(StorageConstants.front))
        model.tack = this.formatIntParameter(localStorage.getItem(StorageConstants.tack))
        model.back = this.formatIntParameter(localStorage.getItem(StorageConstants.back))
        model.namechar = this.formatIntParameter(localStorage.getItem(StorageConstants.namechar))
        model.namethread = this.formatStringParameter(localStorage.getItem(StorageConstants.namethread))
        model.noName = this.formatIntParameter(localStorage.getItem(StorageConstants.noName))
        return model
    }

    private formatIntParameter(value: string | null): string | null {
        if (value == null || value.length <= 0 || value == 'null') {
            return null;
        }
        return value;
    }

    private formatStringParameter(value: string | null): string | null {
        if (value == null || value.length <= 0 || value == 'null') {
            return "";
        }
        return value;
    }

}